import { render } from "./FontSliders.vue?vue&type=template&id=3def3e96"
import script from "./FontSliders.vue?vue&type=script&lang=js"
export * from "./FontSliders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__